import { render, staticRenderFns } from "./indsutrym.vue?vue&type=template&id=80a65b2c&"
import script from "./indsutrym.vue?vue&type=script&lang=js&"
export * from "./indsutrym.vue?vue&type=script&lang=js&"
import style0 from "./indsutrym.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports